export const phoneNumber = "07405844282";

export const whatappPhoneNumber = "447405844282";
